<!-- eslint-disable -->
<template>
  <div class="page_box">
    <div v-loading="pageLoading">
      <se-breadcrumb :itemData="breadData" showBottomBorder> </se-breadcrumb>
      <div class="group_type">
        <div
          :class="formData.type==item.type?'group_type_item group_type_item_active':'group_type_item'"
          v-for="(item,index) in groupTypeList"
          :key="index"
          @click="selectGtypeFn(item.type)">
          <div>{{ item.name }}</div>
          <div>{{ item.context }}</div>
        </div>
      </div>
      <el-form ref="form" :model="formData" :rules="formRules" label-width="140px" class="group-buy-form">
        <div class="form_box">
          <div class="module_title">
            <div class="title_line"></div>
            <div>活动信息</div>
          </div>

          <!-- 表单行容器 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动名称：" prop="activityName">
                <el-input v-model="formData.activityName" placeholder="请输入活动名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动时间：" prop="startTime">
                <el-date-picker
                  v-model="activityDate"
                  @change="activityDateChange"
                  type="datetimerange"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动状态：" prop="status">
                  <el-switch
                    v-model="formData.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="2">
                  </el-switch>
                </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="售卖金额：" prop="price">
                <el-input v-model="formData.price" placeholder="请输入售卖金额" type="number">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="日常价：" prop="referencePrice">
                <el-input v-model="formData.referencePrice" placeholder="请输入日常价" type="number">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="立省金额：" prop="discountPrice">
                <el-input v-model="formData.discountPrice" placeholder="请输入立省金额" type="number">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 全宽表单项目 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动标签：" prop="labels">
                <div class="tags-container">
                  <el-tag
                    size="small"
                    :key="tag"
                    v-for="tag in formData.labels"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                  </el-tag>
                  <el-input
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="mini"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                    placeholder="输入标签后按回车"
                  >
                  </el-input>
                  <el-button v-else size="mini" @click="showInput">+ 新增标签</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 图片上传区域 -->
          <el-row>
            <el-col :span="24">
              <div class="upload-section-title">图片上传</div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="入口图：" prop="icon">
                <file-upload
                  v-model="formData.icon"
                  :uploadBusinessInfo="{
                    businessType: '0'
                  }"
                  :defaultFileList="iconList"
                  :maxNum="1"
                  width="100px"
                  height="100px"
                  @uploadSuccess="uploadSuccess('icon')"
                ></file-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="拼团主图banner：" prop="bannerImage">
                <file-upload
                  v-model="formData.bannerImage"
                  :uploadBusinessInfo="{
                    businessType: '0'
                  }"
                  :defaultFileList="bannerImageList"
                  :maxNum="1"
                  width="100px"
                  height="100px"
                  @uploadSuccess="uploadSuccess('bannerImage')"
                ></file-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="购买流程图：" prop="purchaseImage">
                <file-upload
                  v-model="formData.purchaseImage"
                  :uploadBusinessInfo="{
                    businessType: '0'
                  }"
                  :defaultFileList="purchaseImageList"
                  :maxNum="1"
                  width="100px"
                  height="100px"
                  @uploadSuccess="uploadSuccess('purchaseImage')"
                ></file-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分享图片：" prop="shareImage">
                <file-upload
                  v-model="formData.shareImage"
                  :uploadBusinessInfo="{
                    businessType: '0'
                  }"
                  :defaultFileList="shareImageList"
                  :maxNum="1"
                  width="100px"
                  height="100px"
                  @uploadSuccess="uploadSuccess('shareImage')"
                ></file-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 富文本编辑器 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="拼团详情：" prop="detailContent">
                <div class="editor-container">
                  <custom-editor :option="option" v-model="formData.detailContent"></custom-editor>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="form_box">
          <div class="module_title">
            <div class="title_line"></div>
            <div>活动规则</div>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="成团人数：" prop="groupNum">
                <el-input v-model="formData.groupNum" placeholder="请输入成团人数" type="number">
                  <template slot="suffix">人</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成团有效期：" prop="groupValidTime">
                <el-input v-model="formData.groupValidTime" placeholder="请输入成团有效期" type="number">
                  <template slot="suffix">小时</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 自动成团设置 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否开启自动成团：" prop="hasRobot">
                <el-radio-group v-model="formData.hasRobot">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <div v-if="formData.hasRobot == 1" class="conditional-section">
            <el-row>
              <el-col :span="24">
                <el-form-item prop="robotDelayTime">
                  <div class="conditional-content">
                    <span class="conditional-label">拼单后</span>
                    <el-input v-model="formData.robotDelayTime" placeholder="请输入时间" type="number" style="width: 120px; margin: 0 8px;"></el-input>
                    <span class="conditional-unit">小时开启</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 自动创建模拟团设置 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="自动创建模拟团：" prop="autoCreateTeam">
                <el-radio-group v-model="formData.autoCreateTeam">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <div v-if="formData.autoCreateTeam == 1" class="conditional-section">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="mixTeamCount">
                  <div class="conditional-content">
                    <span class="conditional-label">最小拼团个数：</span>
                    <el-input v-model="formData.mixTeamCount" placeholder="请输入数量" type="number" style="width: 120px;"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="autoCreatTeamCount">
                  <div class="conditional-content">
                    <span class="conditional-label">自动创建个数：</span>
                    <el-input v-model="formData.autoCreatTeamCount" placeholder="请输入数量" type="number" style="width: 120px;"></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item prop="autoTeamRobot">
                  <div class="conditional-content">
                    <span class="conditional-label">单个团机器人个数：</span>
                    <el-radio-group v-model="formData.autoTeamRobot" style="margin-left: 16px;">
                      <el-radio :label="2">固定值</el-radio>
                      <el-radio :label="1">随机数</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item v-if="formData.autoTeamRobot == 2" prop="autoTeamRobotCount">
                  <div class="conditional-content">
                    <span class="conditional-label">固定个数：</span>
                    <el-input v-model="formData.autoTeamRobotCount" placeholder="请输入数量" type="number" style="width: 120px; margin-left: 16px;"></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="form_box">
          <div class="module_title">
            <div class="title_line"></div>
            <div>选择卡</div>
          </div>

          <div class="card-section">
            <div class="card-section-header">
              <el-button class="select-dialog-btn" @click="selectCardFn" type="primary" size="small">
                <i class="el-icon-plus"></i> 选择套餐卡
              </el-button>
              <span class="card-hint">请选择活动关联的套餐卡</span>
            </div>

            <div class="table-container">
              <el-table
                :data="tableDataAll.tableCardData"
                size="medium"
                style="width: 100%"
                :empty-text="'暂无选择的套餐卡'">
                <el-table-column prop="cardTemplateName" label="卡模版名称" min-width="200"></el-table-column>
                <el-table-column prop="" label="有效期限" min-width="200">
                  <template slot-scope="scope">
                    <div>{{ scope.row.validPeriod == -1?'永久': (scope.row.validPeriod == -2 ? '截至到 '+scope.row.validTimeEnd : scope.row.validPeriod + '天')  }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="cardAmount" label="金额（元）" min-width="150"></el-table-column>
                <el-table-column prop="carryingAmount" label="账面金额（元）" min-width="150"></el-table-column>
                <el-table-column prop="address" label="操作" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button class="delete-table-btn" type="text" @click="deleteTableFn('card',scope.$index)" size="small">
                      <i class="el-icon-delete"></i> 删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="form_btn">
      <el-button @click="cancelFn">取消</el-button>
      <el-button type="primary" @click="saveForm">保存</el-button>
      <el-button type="primary" @click="copyFn" v-if="this.$route.query.groupActivityId">一键复制</el-button>
    </div>

    <!-- 卡模版弹窗 -->
    <el-dialog class="dialog_box" title="选择卡模版" :visible.sync="dialogCardVisible" width="80%" :before-close="cardClose" :close-on-click-modal="false">
      <div class="search_store">
        <div>卡模版名称：</div>
        <el-input placeholder="请输入内容" v-model="dialogSearchForm.cardTemplateName" class="input-with-select">
          <el-button @click="getCardList('input')" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-table
        ref="dialogCardTable"
        v-loading="dialogLoading"
        :data="originalCardList"
        @select="selCardChangeFn"
        size="mini"
        style="width: 100%"
        >
        <el-table-column type="selection" width="100" align="center"></el-table-column>
        <el-table-column prop="cardTemplateName" label="卡模版名称" min-width="180"></el-table-column>
        <el-table-column prop="cardAmount" label="开卡金额（元）" min-width="180"></el-table-column>
        <el-table-column prop="carryingAmount" label="账面金额（元）" min-width="180"></el-table-column>
        <el-table-column prop="" label="有效期限" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.validPeriod == -1?'永久': (scope.row.validPeriod == -2 ? '截至到 '+scope.row.validTimeEnd : scope.row.validPeriod + '天')  }}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page_pagination"
        @size-change="handleSizeCardChange"
        @current-change="handleCurrentCardChange"
        :current-page="pageData.num"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total">
      </el-pagination>
      <div class="dialog_btn">
        <el-button @click="cardConfirm(false)" size="mini">取消</el-button>
        <el-button @click="cardConfirm(true)" type="primary" size="mini">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import t from "@common/src/i18n/t";
import {namespace} from "vuex-class";
const marketing = namespace("marketing");

import { emptyToLine, splitThousands } from "@/utils/common";
import FileUpload from "@/components/scope/file-upload.vue";
import { getImageSize } from "@/utils/common";
// 价格验证方法
const checkIsPositive =(rule, value, callback)=> {
  if(!value){
    callback()
  } else {
    const reg = /^\d+(?=\.{0,1}\d+$|$)/
    if (reg.test(value)){
      callback()
    } else {
      callback(new Error('价格需大于等于0'))
    }
  }
}
export default {
  // emptyToLine = emptyToLine;
  // splitThousands = splitThousands;
  //import引入的组件需要注入到对象中才能使用
  // @marketing.Action queryCardTemplateList;
  // @management.Action getStoreList
  // @management.Action getStoreCouponList

  components: { FileUpload },
    data() {
    //这里存放数据
      return {
        isDetail: false,//是否为详情
        pageName: null, //页面名称
        formData: {
          type: 1,                            //拼团类型 1-普通 2-老带新
          activityName: '',                   //活动名称
          startTime: '',                      //活动开始时间
          endTime: '',                        //活动结束时间
          status: 1,                          //拼团状态 1-启用 2-不启用
          price: '',                          //售卖金额
          referencePrice: '',                 //日常价
          discountPrice: '',                  //立省金额
          labels: [],                         //活动标签
          groupNum: '',                       //成团人数
          groupValidTime: '',                 //成团有效期时间
          hasRobot: 0,                        //是否自动成团 1-是 0-否
          robotDelayTime: '',                 //自动成团开启时间

          icon: '',                           //入口图
          bannerImage: '',                    //拼团主图banner
          purchaseImage: '',                  //购买流程图
          shareImage: '',                     //分享图片
          detailContent: '',                 //拼团详情
          radio: 1,                           //是否开启自动成团

          autoCreateTeam: 0,                  // 是否开启自动创建虚拟团 1开启 0不开启
          mixTeamCount: '',  //最小拼团个数
          autoCreatTeamCount: '', //自动创建拼团个数
          autoTeamRobot: 1, //单个自动创建的拼团的机器人个数 1-随机值,2-固定值
          autoTeamRobotCount: '', //单个拼团机器人固定值个数
        },
        formRules: {
          activityName: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],                   //活动名称
          startTime: [
            { required: true, message: '请选择活动时间', trigger: 'change' },
          ],                      //活动开始时间
          endTime: [
            { required: true, message: '请选择活动时间', trigger: 'change' },
          ],                        //活动结束时间
          price: [
            { required: true, message: '请输入售卖金额', trigger: 'blur' },
            { validator: checkIsPositive }
          ],                          //售卖金额
          referencePrice: [
            { required: true, message: '请输入日常价', trigger: 'blur' },
            { validator: checkIsPositive }
          ],                 //日常价
          discountPrice: [
            { required: true, message: '请输入立省金额', trigger: 'blur' },
            { validator: checkIsPositive }
          ],                  //立省金额
          labels: [
            { required: true, message: '请添加活动标签', trigger: 'blur' },
          ],                         //活动标签
          groupNum: [
            { required: true, message: '请设置成团人数', trigger: 'blur' },
          ],                         //成团人数
          groupValidTime: [
            { required: true, message: '请设置成团有效时长', trigger: 'blur' },
          ],                   //成团有效期时间
          robotDelayTime: [
            { required: true, message: '请设置成团开启时长', trigger: 'blur' },
          ],                   //自动成团开启时间

          icon: [
            { required: true, message: '请上传入口图', trigger: 'blur' },
          ],                           //入口图
          bannerImage: [
            { required: true, message: '请上传拼团主图banner', trigger: 'blur' },
          ],                    //拼团主图banner
          purchaseImage: [
            { required: true, message: '请上传流程图', trigger: 'blur' },
          ],                  //购买流程图
          shareImage: [
            { required: true, message: '请上传分享图片', trigger: 'blur' },
          ],                     //分享图片
          detailContent: [
            { required: true, message: '请添加拼团详情', trigger: 'blur' },
          ],                   //分享图片
          mixTeamCount: [
            { required: true, message: '请输入最小拼团个数', trigger: 'blur' },
          ],              //分享图片
          autoCreatTeamCount: [
            { required: true, message: '请输入自动创建拼团个数', trigger: 'blur' },
          ],              //分享图片
          autoTeamRobotCount: [
            { required: true, message: '请输入机器人个数', trigger: 'blur' },
          ],
                           //拼团详情
          subType: [
            { required: true, message: '请输入子坑位', trigger: 'blur' },
          ],
          channel: [
            { required: true, message: '请选择渠道', trigger: 'change' },
          ],
          type: [
            { required: true, message: '请选择页面', trigger: 'change' },
          ],
          parentNo: [
            { required: true, message: '请选择坑位', trigger: 'change' },
          ]
        },
        groupTypeList: [         //拼团类型列表
          { name: '普通拼团', type: 1, context: '用户下单后邀请好友拼团' },
          { name: '老带新拼团', type: 2, context: '新、老用户都可开团，只有新用户可以参团' }
        ],
        activityDate: [],      //活动时间
        iconList: [],
        bannerImageList: [],
        purchaseImageList: [],
        shareImageList: [],
        option: {
          height: 500
        },
        inputVisible: false,
        inputValue: '',
        tableDataAll: {
          tableCardData: [],                        //已选卡模版
        },

        selectCardData: [],                         //选择的卡数据

        pageData: {                                 //分页数据
          num: 1,
          size: 10,
          total: 0
        },
        pageLoading: false,                         //页面loading
        dialogLoading: false,                       //弹窗加载
        dialogCardVisible: false,                    //卡模版弹窗
        originalCardList: [],                     //原卡模版列表
        dialogSearchForm: {
          storeCode: '',
          cardTemplateName: ''
        },                       //弹窗筛选数据
      };
    },
  //监听属性 类似于data概念
  computed: {
    breadData() {
      return [
        { name: "拼团活动", path: "/management/groupBuying/groupActivity/list" },
        {
          name: this.pageName
        }
      ];
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 拼团类型选择
    selectGtypeFn(type){
      this.formData.type = type;
    },

    // 活动时间选择
    activityDateChange(e){
      this.formData.startTime = e[0];
      this.formData.endTime = e[1];
    },

    // 标签删除
    handleClose(tag) {
      this.formData.labels.splice(this.formData.labels.indexOf(tag), 1);
    },
    // 新增标签展示input
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 新增标签确认
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.formData.labels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    // 图片上传成功
    uploadSuccess(e){
      this.$refs.form.clearValidate(e)
    },


    // 卡模版，优惠券反显
    backDisplayFn(type){
      if(type == 'card'){
        let selectCardData = this.selectCardData;
        let originalCardList = this.originalCardList;
        if(selectCardData.length>0){
          selectCardData.forEach(item => {
            originalCardList.forEach(ele => {
              if(item.cardTemplateCode == ele.cardTemplateCode){
                this.$refs.dialogCardTable.toggleRowSelection(ele);
              }
            })
          })
        }
      }
      if(type == 'coupon'){
        let selectCouponData = this.selectCouponData;
        let originalCouponList = this.originalCouponList;
        if(selectCouponData.length>0){
          selectCouponData.forEach(item => {
            originalCouponList.forEach(ele => {
              if(item.activityCode == ele.activityCode){
                this.$refs.dialogCouponTable.toggleRowSelection(ele);
              }
            })
          })
        }
      }
    },

    // 选择卡模版
    selectCardFn(){
      this.pageData = {                                 //分页数据
        num: 1,
        size: 10,
        total: 0
      },
      this.getCardList().then(res =>{
        this.selectCardData = JSON.parse(JSON.stringify(this.tableDataAll.tableCardData))
        this.backDisplayFn('card')
      });

      this.dialogCardVisible = true;
    },
    // 卡模版翻页
    handleCurrentCardChange(e){
      this.pageData.num = e;
      this.getCardList().then(res =>{
        this.backDisplayFn('card')
      });

    },
    // 卡模版选择每页条数
    handleSizeCardChange(e){
      this.pageData.size = e;
      this.getCardList().then(res =>{
        this.backDisplayFn('card')
      });

    },
    // 卡模版弹窗按钮操作
    cardConfirm(type){
      if(type){
        if(this.selectCardData.length>0){
          this.tableDataAll.tableCardData = JSON.parse(JSON.stringify(this.selectCardData));
          this.dialogCardVisible = false;
        }else{
          this.$message.warning('请选择套餐卡')
        }
      }else{
        this.selectCardData = [];
        this.dialogCardVisible = false;
      }
    },
    // 卡模版弹窗关闭按钮
    cardClose(done){
      done();
      this.selectCardData = [];
    },
    // 卡模版弹窗列表checked change
    selCardChangeFn(rows, row){
      let selectCardData = this.selectCardData;       //确认选择前暂存数据字段
      let isChecked = rows.some(item => item.cardTemplateCode == row.cardTemplateCode); //判断是选中还是取消
      if(isChecked){
        selectCardData.push(row);
      }else{
        this.selectCardData = selectCardData.filter(item => item.cardTemplateCode != row.cardTemplateCode);  //去掉取消选中的数据
      }
    },
    // 已选列表删除
    deleteTableFn(type, index){
      if(type == 'card'){
        this.$confirm('是否删除此卡?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableDataAll.tableCardData.splice(index,1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      if(type == 'coupon'){
        this.$confirm('是否删除此优惠券?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableDataAll.tableCouponData.splice(index,1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      console.log(index)
    },
    copyFn(){
      // return
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.tableDataAll.tableCardData.length<1){
            this.$message.warning('请选择套餐卡')
            return
          }
          if(this.isNext) return;
          this.isNext = true;
          this.pageLoading = true;
          this.$store.dispatch(`management/groupActivityAdd`,{
            ...this.formData,
            groupActivityId: '',
            cardTemplateList: this.tableDataAll.tableCardData
          }).then(res => {
            this.$message.success('保存成功！')
            this.$router.back()
            this.isNext = false;
            this.pageLoading = false;
          }).catch(err => {
            this.isNext = false;
            this.pageLoading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 表单保存
    saveForm(){
      // return
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.tableDataAll.tableCardData.length<1){
            this.$message.warning('请选择套餐卡')
            return
          }
          if(this.isNext) return;
          this.isNext = true;
          this.pageLoading = true;
          this.$store.dispatch(`management/groupActivityAdd`,{
            ...this.formData,
            groupActivityId: this.$route.query.groupActivityId||'',
            cardTemplateList: this.tableDataAll.tableCardData
          }).then(res => {
            this.$message.success('保存成功！')
            this.$router.back()
            this.isNext = false;
            this.pageLoading = false;
          }).catch(err => {
            this.isNext = false;
            this.pageLoading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消
    cancelFn(){
      this.$router.back();
    },

    getDetail(groupActivityId){
      this.$store.dispatch('management/groupActivityDetail',{
        groupActivityId
      }).then(res => {
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = res.data[key] || '';
        })
        this.tableDataAll.tableCardData = res.data.cardTemplateList;
        this.iconList = [{url: res.data.icon}];
        this.bannerImageList = [{url: res.data.bannerImage}];
        this.purchaseImageList = [{url: res.data.purchaseImage}];
        this.shareImageList = [{url: res.data.shareImage}];
        this.activityDate = [ res.data.startTime, res.data.endTime ];
      })
    },

    // 获取卡模版列表
    async getCardList(type=''){
      if(type == 'input'){
        this.pageData = {                                 //分页数据
          num: 1,
          size: 10,
          total: 0
        }
      }
      this.dialogLoading = true;
      await this.$store.dispatch('marketing/queryCardTemplateList',{
        pageNum: this.pageData.num,
        pageSize: this.pageData.size,
        cardTemplateName: this.dialogSearchForm.cardTemplateName,
        enableStatus: 1,
      }).then(res => {
        this.originalCardList = res.data.list || [];
        this.pageData.total = res.data.total;
        this.dialogLoading = false;
        if(type == 'input'){
          setTimeout(() => {
            this.backDisplayFn('card')
          }, 0);
        }
      })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 获取当前路由的名称
    this.isDetail = this.$route.name === "groupActivityDetail";
    this.pageName = this.$route.meta.title;
    if (this.$route.query.groupActivityId) {
      this.getDetail(this.$route.query.groupActivityId);
    }

  },

  beforeRouteEnter (to, from, next) {
    // `from` 是跳转前的路由对象
    console.log('From:', from);
    next();
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
  // 移除全局变量导入，直接使用具体值

  // 移除所有Sass变量，直接使用具体值

  // 页面基础样式
  .page_box {
    padding: 24px;
    box-sizing: border-box;
    background: #f9fafb;
    min-height: 100vh;

    // 面包屑导航样式
    .se-breadcrumb {
      margin-bottom: 24px;
      background: #ffffff;
      padding: 16px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #e5e7eb;

      a {
        color: #1f2937;
        font-weight: 600;
        position: relative;
        z-index: 1;

        &:hover {
          color: #3b82f6;
        }
      }
    }

    // 卡片式表单容器
    .form_box {
      background: #ffffff;
      padding: 24px;
      box-sizing: border-box;
      width: 100%;
      margin-top: 20px;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #e5e7eb;

      // 模块标题
      .module_title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: #1f2937;
        margin-bottom: 20px;

        .title_line {
          width: 4px;
          height: 20px;
          background: #3b82f6;
          margin-right: 12px;
          border-radius: 2px;
        }
      }


    }

    // 表单按钮区域
    .form_btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      background: #ffffff;
      padding: 24px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      margin-top: 24px;
      border: 1px solid #e5e7eb;

      .el-button {
        padding: 10px 20px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        transition: all 0.2s ease;

        // 小尺寸按钮样式
        &.el-button--small {
          padding: 8px 16px;
          font-size: 13px;
          height: 32px;
          line-height: 16px;
        }

        // 迷你尺寸按钮样式
        &.el-button--mini {
          padding: 6px 12px;
          font-size: 12px;
          height: 28px;
          line-height: 16px;
        }
      }

      .el-button--primary {
        background: #3b82f6;
        border: 1px solid #3b82f6;
        color: white;
      }

      .el-button--default {
        border: 1px solid #d9d9d9;
        color: #6b7280;
        background: #ffffff;
      }
    }
  }

  // 拼团类型选择
  .group_type {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    flex-wrap: wrap;
    margin-top: 24px;

    .group_type_item {
      background: #ffffff;
      text-align: center;
      width: 300px;
      height: 150px;
      padding: 32px 24px;
      box-sizing: border-box;
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      cursor: pointer;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      position: relative;

      div:nth-child(1) {
        font-weight: 600;
        font-size: 18px;
        color: #1f2937;
        margin-bottom: 16px;
      }

      div:nth-child(2) {
        font-size: 14px;
        color: #4b5563;
        line-height: 1.6;
        font-weight: 400;
      }
    }

    .group_type_item_active {
      border: 2px solid #3b82f6;
      background: #dbeafe;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      div:nth-child(1) {
        color: #3b82f6;
      }

      div:nth-child(2) {
        color: #1f2937;
      }
    }
  }

  // 标签样式
  ::v-deep .el-tag{
    + .el-tag {
      margin-left: 8px;
    }

    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 12px;
    border: 1px solid #e5e7eb;
    background: #dbeafe;
    color: #3b82f6;
    transition: all 0.2s ease;

    .el-tag__close {
      color: #3b82f6;
      opacity: 0.8;
      font-size: 14px;
      transition: all 0.2s ease;
    }

    // 小尺寸标签样式
    &.el-tag--small {
      padding: 4px 10px;
      font-size: 13px;
      height: 26px;
      line-height: 18px;
      border-radius: 4px;
    }

    // 迷你尺寸标签样式
    &.el-tag--mini {
      padding: 2px 8px;
      font-size: 12px;
      height: 22px;
      line-height: 16px;
      border-radius: 4px;
    }
  }

  // 标签不同类型样式
  ::v-deep .el-tag--success{
    background: #d1fae5;
    border-color: #10b981;
    color: #10b981;
  }

  ::v-deep .el-tag--warning{
    background: #fef3c7;
    border-color: #f59e0b;
    color: #f59e0b;
  }

  ::v-deep .el-tag--danger{
    background: #fee2e2;
    border-color: #ef4444;
    color: #ef4444;
  }

  .button-new-tag {
    margin-left: 16px;
    height: 32px;
    line-height: 28px;
    padding: 0 16px;
    border-radius: 4px;
    border: 1px dashed #3b82f6;
    color: #3b82f6;
    background: transparent;
    font-weight: 500;
    font-size: 14px;
  }

  .input-new-tag {
    width: 120px !important;
    margin-left: 16px;
    vertical-align: bottom;

    .el-input__inner {
      border-radius: 4px;
      border: 1px solid #3b82f6;
      padding: 8px 12px;
      font-size: 14px;
      font-weight: 500;
      color: #3b82f6;

      &:focus {
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  // 对话框样式
  .dialog_box {
    ::v-deep .el-dialog{
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #e5e7eb;
      background: #ffffff;
    }

    ::v-deep .el-dialog__header{
      border-bottom: 1px solid #e5e7eb;
      padding: 16px 20px;
      background: #f9fafb;

      .el-dialog__title {
        color: #4b5563;
        font-weight: 500;
        font-size: 16px;
        margin: 0;
      }

      .el-dialog__headerbtn {
        font-size: 16px;
        color: #9ca3af;

        &:hover {
          color: #6b7280;
        }
      }
    }

    ::v-deep .el-dialog__body{
      padding: 20px;
      background: #ffffff;
      color: #1f2937;
      font-size: 14px;
      line-height: 1.6;
    }

    ::v-deep .el-dialog__footer{
      border-top: 1px solid #e5e7eb;
      padding: 16px 20px;
      background: #ffffff;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }

    // 弹窗内按钮样式
    .dialog_btn {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
      padding-top: 16px;
      border-top: 1px solid #e5e7eb;
    }

    // 搜索区域
    .search_store {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      gap: 16px;
      //background: #ffffff;
      //padding: 16px 20px;
      //border-radius: 4px;
      //box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      //border: 1px solid #e5e7eb;

      ::v-deep .el-input{
        width: 400px;
        min-width: 250px;
        flex: 1;

        .el-input__inner {
          border-radius: 4px;
          padding: 10px 16px;
          font-size: 14px;
          font-weight: 500;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;

          &:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
          }
        }
      }

      div {
        font-weight: 500;
        color: #1f2937;
        white-space: nowrap;
      }
    }

    // 弹窗内表格样式
    ::v-deep .el-table{
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      border: 1px solid #e5e7eb;
      margin-bottom: 20px;
      background: #ffffff;

      // 表格头部样式
      .el-table__header-wrapper {
        .el-table__header {
          th {
            background: #f9fafb;
            color: #4b5563;
            font-weight: 500;
            font-size: 14px;
            padding: 12px 16px;
            border-bottom: 1px solid #e5e7eb;
          }
        }
      }

      // 表格主体样式
      .el-table__body-wrapper {
        .el-table__body {
          td {
            padding: 12px 16px;
            border-bottom: 1px solid #e5e7eb;
            font-size: 14px;
            color: #1f2937;
          }

          tr {
            transition: all 0.2s ease;

            &:hover {
              background: #f9fafb;
            }
          }
        }
      }

      // 表格边框样式
      &.el-table--border {
        th,
        td {
          border-right: 1px solid #e5e7eb;
        }

        th.gutter {
          border-right: 1px solid #e5e7eb;
        }
      }
    }

    // 分页样式
    .page_pagination {
      text-align: center;
      margin-top: 24px;
      //background: #ffffff;
      //padding: 16px;
      //border-radius: 4px;
      //box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      //border: 1px solid #e5e7eb;

      //::v-deep .el-pagination{
      //  .el-pager li {
      //    border-radius: 4px;
      //    font-weight: 500;
      //    padding: 6px 12px;
      //    margin: 0 4px;
      //
      //    &:hover {
      //      color: #3b82f6;
      //      border-color: #3b82f6;
      //    }
      //
      //    &.active {
      //      background: #3b82f6;
      //      border-color: #3b82f6;
      //      color: white;
      //    }
      //  }
      //
      //  .el-pagination__prev,
      //  .el-pagination__next {
      //    border-radius: 4px;
      //    padding: 6px 12px;
      //    font-weight: 500;
      //
      //    &:hover {
      //      color: #3b82f6;
      //      border-color: #3b82f6;
      //    }
      //  }
      //}
    }

    // 对话框按钮
    .dialog_btn {
      text-align: end;
      margin-top: 24px;
      gap: 16px;
      display: flex;
      justify-content: flex-end;

      ::v-deep .el-button{
        border-radius: 4px;
        padding: 8px 16px;
        font-weight: 500;
        font-size: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      ::v-deep .el-button--primary {
        background: #3b82f6;
        border: 1px solid #3b82f6;
        color: white;
      }

      ::v-deep .el-button--default {
        border: 1px solid #d9d9d9;
        color: #6b7280;
        background: #ffffff;
      }
    }
  }

  // 表格表单
  .table_form {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
  }

  // 日期选择器样式
  ::v-deep .el-date-editor{
    .el-input__inner {
      border-radius: 6px;


      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  // 开关样式
  ::v-deep .el-switch{
    &.el-switch--active {
      .el-switch__core {
        background-color: #10b981;
      }
    }
  }

  // 单选框样式
  ::v-deep .el-radio{
    margin-right: 20px;
  }

  ::v-deep .el-radio__input.is-checked{
    + .el-radio__label {
      color: #3b82f6;
    }

    .el-radio__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
    }
  }

  // 多选框样式
  ::v-deep .el-checkbox{
    margin-right: 20px;
  }

  ::v-deep .el-checkbox__input.is-checked{
    + .el-checkbox__label {
      color: #3b82f6;
    }

    .el-checkbox__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
    }
  }

  // 表格表单
  .table_form {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
  }

  // 统一输入框样式
  ::v-deep .el-input{
    .el-input__inner {
      border-radius: 12px;
      border: 2px solid #e5e7eb;
      padding: 14px 20px;
      font-size: 15px;
      font-weight: 500;
      color: #1f2937;
      background: rgba(255, 255, 255, 0.95);
      transition: all 0.3s ease;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
      }
    }
  }

  // 日期选择器样式
  ::v-deep .el-date-editor{
    .el-input__inner {
      border-radius: 12px;
      padding: 14px 20px;
      border: 2px solid #e5e7eb;
      transition: all 0.3s ease;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
      }
    }
  }

  // 开关样式
  ::v-deep .el-switch{
    margin-top: 0;

    &.el-switch--active {
      .el-switch__core {
        background-color: #10b981;
      }
    }
  }

  // 单选框样式
  ::v-deep .el-radio{
    margin-right: 20px;
  }

  ::v-deep .el-radio__input.is-checked{
    + .el-radio__label {
      color: #3b82f6;
    }

    .el-radio__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
    }
  }

  // 多选框样式
  ::v-deep .el-checkbox{
    margin-right: 20px;
  }

  ::v-deep .el-checkbox__input.is-checked{
    + .el-checkbox__label {
      color: #3b82f6;
    }

    .el-checkbox__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
    }
  }

  // 表格容器样式
  .table-container {
    margin-top: 24px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
    background: #ffffff;
  }

  // 选择套餐卡按钮
  .select-dialog-btn {
    border-radius: 4px;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    background: #3b82f6;
    border: 1px solid #3b82f6;
    color: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 10px 24px;
  }

  // 删除表格行按钮
  .delete-table-btn {
    color: #ef4444 !important;
    font-size: 14px;
  }

  // 表单按钮区域
  .form_btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    margin-top: 24px;
  }
  // 标签容器
  .tags-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    background: #ffffff;
    padding: 12px;
    border-radius: 4px;
    border: 1px dashed #e5e7eb;
  }

  // 图片上传区域
  .image-upload-section {
    margin-bottom: 24px;

    .upload-section-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      margin-bottom: 16px;
    }

    .upload-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 24px;
    }
  }

  // 富文本编辑器容器
  .editor-container {
    background: white;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    padding: 16px;
  }

  // 规则区块
  .rule-section {
    background: #ffffff;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border: 1px solid #e5e7eb;
  }

  // 条件显示区块
  .conditional-section {
    background: white;
    margin-top: 16px;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    border-left: 4px solid #3b82f6;
  }

  // 条件内容
  .conditional-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  // 条件标签
  .conditional-label {
    font-weight: 500;
    color: #1f2937;
    white-space: nowrap;
  }

  // 条件单位
  .conditional-unit {
    font-weight: 500;
    color: #4b5563;
    white-space: nowrap;
  }

  // 卡片选择区域
  .card-section {
    .card-section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      flex-wrap: wrap;
      gap: 12px;
    }

    .card-hint {
      font-size: 14px;
      color: #4b5563;
    }
  }
</style>
